import { render, staticRenderFns } from "./roles_list_fing.vue?vue&type=template&id=0dde7752"
import script from "./roles_list_fing.vue?vue&type=script&lang=js"
export * from "./roles_list_fing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports